import styled from "styled-components";

const CustomerWrapper = styled.div`
  .customer-header {
    @media (min-width: 869px) {
      margin-top: -25px;
      padding: 100px 35px 240px 35px;
      flex-direction: row !important;
    }

    @media (max-width: 868px) {
      padding: 15px 30px 300px;
      margin: -25px -13px 0;

      &--name {
        white-space: normal;
        margin-bottom: 15px;
      }
    }
  }

  .data-customer-header {
    @media (min-width: 869px) {
      padding: 100px 35px 160px;
    }

    @media (max-width: 868px) {
      padding: 15px 30px 300px;
    }
  }

  .customer-content {
    @media (min-width: 869px) {
      margin-top: -170px;
    }

    @media (min-width: 1225px) {
      margin-top: -150px;
    }

    @media (max-width: 868px) {
      margin-top: -280px;
    }

    &--buttons {
      margin-top: 15px;

      @media (min-width: 869px) {
        margin-top: -60px;
      }
    }

    &--infos {
      @media (min-width: 869px) {
        // height: 230px;
      }

      @media (max-width: 441px) {
        flex-direction: column;
      }
    }

    &--notes {
      overflow: hidden;
    }

    &--graphs {
      display: block;

      div.min-w-30 {
        min-width: 32.7%;

        :nth-child(n + 1) {
          margin-right: 10px;
        }

        :nth-child(3n) {
          margin-right: 0;
        }
      }

      div.w-30 {
        width: 32.7%;

        :nth-child(n + 1) {
          margin-right: 10px;
        }

        :nth-child(3n) {
          margin-right: 0;
        }
      }

      @media (max-width: 1165px) {
        div.min-w-30 {
          min-width: 32.6%;
        }

        div.w-30 {
          width: 32.6%;
        }
      }

      @media (max-width: 1020px) {
        div.min-w-30 {
          min-width: 32.5%;
        }

        div.w-30 {
          width: 32.5%;
        }
      }

      @media (max-width: 950px) {
        div.min-w-30 {
          min-width: 100%;
        }

        div.w-30 {
          width: 100%;
        }
      }
    }
  }
`;

export default {
  CustomerWrapper,
};
